function hasInputValue(value: string): boolean {
  return value.trim().length > 0
}

export function shouldEnableCountAvailableDaysOnly(
  minimumSchedulingNotice: string,
  dateRange: string
): boolean {
  return hasInputValue(minimumSchedulingNotice) || hasInputValue(dateRange)
}

export function resolveCountAvailableDaysOnly(
  userIntent: boolean,
  minimumSchedulingNotice: string,
  dateRange: string
): boolean {
  return (
    userIntent &&
    shouldEnableCountAvailableDaysOnly(minimumSchedulingNotice, dateRange)
  )
}
